'use client';

// Providers
import { useEmployee } from '@/providers';

// Constants
import { UserStatus } from '@shared/constants';
export const InactiveEmployeeOverlay = () => {
  const {
    info
  } = useEmployee();
  const isEmployeeDeactivated = info?.status === UserStatus.INACTIVE;

  // Only show overlay if the employee is deactivated
  return isEmployeeDeactivated && <div className="absolute inset-0 bg-slate-600/40 z-30 cursor-not-allowed" />;
};